import React from "react";
import {Table} from "react-bootstrap";
import {
    AiOutlineCheckCircle,
    AiOutlineClockCircle,
    AiOutlineCloseCircle,
    AiOutlineSearch,
} from "react-icons/ai";

const EVENT_STEP_LABELS = {
    getDocFieldByModel: "Classificar Tipo",
    extractorAttachmentFields: "Indexar (OCR)",
    createSmartTitle: "Classificar Título",
    createImageThumbnails: "Thumbnail",
    transcription: "Transcrição",
    offerInsights: "Analisar Sentimento",
    trainingModel: "Treinar IA Corporativa",
};

const EVENT_STEPS = Object.keys(EVENT_STEP_LABELS);

const renderStatusBadge = (status) => {
    switch (status) {
        case "PROCESSED":
            return (
                <AiOutlineCheckCircle fontSize={24} className="text-success"/>
            );
        case "WAIT":
            return (
                <span style={{maxWidth: 140}}
                      className="badge rounded-pill bg-warning text-dark px-8 py-2 d-flex align-items-center gap-1">
          <AiOutlineClockCircle fontSize={14}/> Aguardando
        </span>
            );
        case "ERROR":
            return (
                <span style={{maxWidth: 140}}
                      className="badge rounded-pill bg-danger text-white px-8 py-2 d-flex align-items-center gap-1">
          <AiOutlineCloseCircle fontSize={14}/> Erro
        </span>
            );
        default:
            return <span style={{maxWidth: 140}} className="text-muted">—</span>;
    }
};

const DocEventSearchTable = ({results}) => {
    const getStepStatus = (steps, stepId) => {
        const step = steps?.find((s) => s?.id === stepId);
        return step?.status || null;
    };

    const handleNavigate = (documentId) => {
        window.location.href = `/document/${documentId}`;
    };

    const getDocDisplayName = (event) => {
        const {documentSummary} = event || {};

        const summaryFields = JSON.parse(documentSummary?.summaryFields || null)

        const attachments = summaryFields?.attachments || [];
        const fields = summaryFields?.fields || [];

        const hasContent =
            !!summaryFields?.displayName ||
            attachments.length > 0 ||
            fields.length > 0;

        return (
            <div>
                {hasContent ? (
                    <>
                        {summaryFields?.displayName && (
                            <div>
                                <strong>{summaryFields.displayName}</strong>
                            </div>
                        )}

                        <div className="text-muted small">
                            {attachments.length > 0 && (
                                <span>
                                    [{attachments.map((att) => att.originalName).join(", ")}]&nbsp;&nbsp;
                                </span>
                            )}

                            {fields.length > 0 && (
                                    <span>
                                        {fields.slice(0, 2).map((field, index) => (
                                            <span key={index}>
                  <strong>{field.name}:</strong> {field.value}
                                                {index === 0 && fields.length > 1 ? " | " : ""}
                </span>
                                        ))}
                                        {fields.length > 2 && <span> ...</span>}
                                    </span>
                            )}
                        </div>



                    </>
                ) : (
                    <div className="text-muted small">{event?.documentId}</div>
                )}
            </div>
        );
    };

    return (
        <div className="table-responsive">
            <Table hover striped className="table">
                <thead>
                <tr>
                    <th></th>
                    <th style={{width: '35%'}}>Documento</th>
                    <th style={{width: '15%'}}>Última Modificação</th>
                    {EVENT_STEPS.map((stepId) => (
                        <th key={stepId} className="text-center">{EVENT_STEP_LABELS[stepId]}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {results?.map((event, index) => (
                    <tr key={index}>
                        <td style={{width: "40px", textAlign: "center"}}>
                            <AiOutlineSearch
                                style={{cursor: "pointer", fontSize: "1.2rem"}}
                                onClick={() => handleNavigate(event.documentId)}
                                title="Visualizar Documento"
                            />
                        </td>
                        <td>
                            {
                                getDocDisplayName(event)
                            }
                        </td>
                        <td>{new Date(event.lastModify).toLocaleString('pt-BR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        })}</td>

                        {EVENT_STEPS.map((stepId) => (
                            <td key={stepId} className="text-center" style={{justifyItems: "center"}}>
                                {renderStatusBadge(getStepStatus(event.steps, stepId))}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </Table>
        </div>
    );
};

export default DocEventSearchTable;
